import Ai from '../assets/additionalQuestions/ai';
import ChallengeAnswer from '../assets/additionalQuestions/challengeAnswer';
import CodeAnswer from '../assets/additionalQuestions/codeAnswer';
import MultipleChoice from '../assets/additionalQuestions/multipleChoice';
import TextAnswer from '../assets/additionalQuestions/textAnswer';
import UploadFile from '../assets/additionalQuestions/uploadFile';
import Video from '../assets/additionalQuestions/video';
import Draw from '../assets/additionalQuestions/draw';
import { AnswerTypeEnum, StrategyValues } from '../constants/enums';
import { t } from '../i18n/i18n';
import { isAiInterviewStrategy, isNormalStrategy } from './testgroups';

export function getQuestionTypeButton(
  testGroupABM,
  iconButton = true,
  strategy = StrategyValues.NORMAL
) {
  return [
    {
      id: AnswerTypeEnum.CHECK,
      disableIds: [AnswerTypeEnum.CHECK],
      name: t('CREATE_SCREENING_YOUR_QUESTIONS_CHECK'),
      track: 'create-screening-multiple-question',
      show: isNormalStrategy(strategy),
      img: <MultipleChoice />,
      isPremiumFeature: false,
    },
    {
      id: AnswerTypeEnum.CHALLENGE_ASYNC_AI,
      disableIds: [AnswerTypeEnum.CHALLENGE_ASYNC_AI],
      name: t('CREATE_SCREENING_YOUR_QUESTIONS_CHALLENGE_ASYNC'),
      track: 'create-screening-challenge-async-question',
      show: iconButton && isNormalStrategy(strategy),
      img: <ChallengeAnswer />,
      isPremiumFeature: true,
    },
    {
      id:
        testGroupABM || isAiInterviewStrategy(strategy)
          ? AnswerTypeEnum.TEXT_AI
          : AnswerTypeEnum.TEXT,
      disableIds: [AnswerTypeEnum.TEXT, AnswerTypeEnum.TEXT_AI],
      name: t('CREATE_SCREENING_YOUR_QUESTIONS_TEXT'),
      track: 'create-screening-text-question',
      show: isNormalStrategy(strategy) || isAiInterviewStrategy(strategy),
      img: <TextAnswer />,
      isPremiumFeature: false,
      img2: iconButton && <Ai />,
    },
    {
      id: AnswerTypeEnum.FILE,
      disableIds: [AnswerTypeEnum.FILE],
      name: t('CREATE_SCREENING_YOUR_QUESTIONS_FILE'),
      track: 'create-screening-file-question',
      show: isNormalStrategy(strategy),
      isPremiumFeature: false,
      img: <UploadFile />,
    },
    {
      id: AnswerTypeEnum.VIDEO,
      disableIds: [AnswerTypeEnum.VIDEO],
      name: t('CREATE_SCREENING_YOUR_QUESTIONS_VIDEO'),
      track: 'create-screening-video-question',
      show: iconButton && isNormalStrategy(strategy) && !testGroupABM,
      isPremiumFeature: !testGroupABM,
      img: <Video />,
      img2: iconButton && <Ai />,
    },
    {
      id: AnswerTypeEnum.VIDEO,
      disableIds: [AnswerTypeEnum.VIDEO, AnswerTypeEnum.VIDEO_AI],
      name: t('CREATE_SCREENING_YOUR_QUESTIONS_VIDEO'),
      track: 'create-screening-video-question',
      show: iconButton && isNormalStrategy(strategy) && testGroupABM,
      isPremiumFeature: false,
      img: <Video />,
      img2: iconButton && <Ai />,
    },
    {
      id: AnswerTypeEnum.CODE_AI,
      disableIds: [AnswerTypeEnum.CODE, AnswerTypeEnum.CODE_AI],
      name: t('CREATE_SCREENING_YOUR_QUESTIONS_CODE'),
      track: 'create-screening-code-question',
      show: isNormalStrategy(strategy),
      isPremiumFeature: true,
      img: <CodeAnswer />,
    },
    {
      id: AnswerTypeEnum.DRAW,
      disableIds: [AnswerTypeEnum.DRAW],
      name: t('CREATE_SCREENING_YOUR_QUESTIONS_DRAW'),
      track: 'create-screening-draw-question',
      show: testGroupABM && isNormalStrategy(strategy),
      isPremiumFeature: false,
      img: <Draw />,
    },
  ];
}
